<template>
  <div>
    <el-card :span="6">
      <el-form ref="searchForm" :model="searchForm">
        <el-row :gutter="20">
          <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="4">
            <el-form-item label="" prop="name">
              <el-input style="width: 100%;" :size="componentSize" v-model="searchForm.name" placeholder="请输入阶段名称" @keyup.enter.native="pageList" auto-complete="off" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="4">
            <el-form-item>
              <el-button :size="componentSize" type="primary" @click="pageList" icon="el-icon-search">搜索</el-button>
              <el-button :size="componentSize" type="primary" @click="reset" icon="el-icon-refresh">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <el-card :span="6" style="margin-top: 20px;">
      <el-row :span="24">
        <el-col :span="12">
        <el-button :size="componentSize" type="primary" @click="addFormVisible = true" icon="el-icon-plus">新增</el-button>
        <el-button :size="componentSize" type="danger" @click="batchDeleteProjectPhase" icon="el-icon-minus">批量删除</el-button>
        </el-col>
        <el-col style="text-align: right" :span="12">
          <el-button :size="componentSize" type="primary" @click="importFormVisible = true" icon="el-icon-download">导入</el-button>
          <el-button :size="componentSize" style="text-align: right" type="primary" @click="exportExcel" :loading="loading" icon="el-icon-upload2">导出</el-button>
        </el-col>
      </el-row>
      <el-table :size="componentSize" ref="multipleTable" :data="page.rows" tooltip-effect="dark" style="margin-top: 20px; width: 100%;"
                border v-loading="tableLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)" @selection-change="selectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="projectId" label="项目"></el-table-column>
        <el-table-column prop="name" label="阶段名称"></el-table-column>
        <el-table-column prop="sn" label="序号"></el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
        <el-table-column prop="learningOrder" label="学习顺序"></el-table-column>
        <el-table-column prop="gradeReward" label="学分奖励"></el-table-column>
        <el-table-column prop="learningRate" label="学习进度"></el-table-column>
        <el-table-column prop="certificateReward" label="证书奖励"></el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column prop="operatorId" label="操作人id"></el-table-column>
        <el-table-column prop="state" label="标识1：有效 -1：被删除"></el-table-column>
        <el-table-column prop="" label="启用/禁用" width="120">
          <template slot-scope="scope">
            <el-switch class="switch-style" :size="componentSize" @change="active(scope.row)" :active-value="1" :inactive-value="-1" active-text="启"
                                   inactive-text="禁" v-model="scope.row.active" active-color="#409EFF"
                                   inactive-color="#D2D2D2"></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="" label="操作" width="80" align="center">
          <template slot-scope="scope">
            <div class="operationGroup">
              <span @click="selection = scope.row.id, detailFormVisible = true"><i class="el-icon-view" title="查看"></i></span>
              <span @click="selection = scope.row.id, editFormVisible = true"><i class="el-icon-edit"  title="编辑"></i></span>
              <span @click="deleteProjectPhase(scope.row)"><i class="el-icon-delete" title="删除"></i></span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="total, sizes, prev, pager, next, jumper" style="margin-top: 20px;text-align: right;"
                     :total="page.total" :page-size="page.pageSize" :current-page="page.pageNumber"
                     @size-change="sizeChange" @current-change="currentChange">
      </el-pagination>
    </el-card>

    <el-dialog title="新增" :visible.sync="addFormVisible" :width="addFormDialogWidth" left>
      <el-form ref="addForm" :model="addForm" :label-width="formLabelWidth" :rules="addFormRules">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="项目" prop="projectId">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="addForm.projectId" placeholder="请输入项目" auto-complete="off" maxlength="19" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="阶段名称" prop="name">
              <el-input style="width: 100%;" :size="componentSize" v-model="addForm.name" placeholder="请输入阶段名称" auto-complete="off" maxlength="255" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="序号" prop="sn">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="addForm.sn" placeholder="请输入序号" auto-complete="off" maxlength="10" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注" prop="remark">
              <el-input style="width: 100%;" :size="componentSize" v-model="addForm.remark" placeholder="请输入备注" auto-complete="off" maxlength="255" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学习顺序" prop="learningOrder">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="addForm.learningOrder" placeholder="请输入学习顺序" auto-complete="off" maxlength="10" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学分奖励" prop="gradeReward">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="addForm.gradeReward" placeholder="请输入学分奖励" auto-complete="off" maxlength="10" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学习进度" prop="learningRate">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="addForm.learningRate" placeholder="请输入学习进度" auto-complete="off" maxlength="10" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证书奖励" prop="certificateReward">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="addForm.certificateReward" placeholder="请输入证书奖励" auto-complete="off" maxlength="19" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建时间" prop="createTime">
              <el-date-picker style="width: 100%;" :size="componentSize"
                v-model="addForm.createTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                align="right"
                placeholder="选择日期时间"
                :picker-options="pickerOptions" clearable>
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="操作人id" prop="operatorId">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="addForm.operatorId" placeholder="请输入操作人id" auto-complete="off" maxlength="19" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="标识1：有效 -1：被删除" prop="state">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="addForm.state" placeholder="请输入标识1：有效 -1：被删除" auto-complete="off" maxlength="10" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button :size="componentSize" @click="addFormVisible = false">取 消</el-button>
        <el-button :size="componentSize" type="primary" @click="addProjectPhase">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="查看" :visible.sync="detailFormVisible" :width="detailFormDialogWidth" left>
      <el-form class="detail-form-dialog" ref="detailForm" :model="detailForm" :label-width="formLabelWidth">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="项目" prop="projectId">
              {{detailForm.projectId}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="阶段名称" prop="name">
              {{detailForm.name}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="序号" prop="sn">
              {{detailForm.sn}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注" prop="remark">
              {{detailForm.remark}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学习顺序" prop="learningOrder">
              {{detailForm.learningOrder}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学分奖励" prop="gradeReward">
              {{detailForm.gradeReward}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学习进度" prop="learningRate">
              {{detailForm.learningRate}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证书奖励" prop="certificateReward">
              {{detailForm.certificateReward}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="创建时间" prop="createTime">
              {{detailForm.createTime}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="操作人id" prop="operatorId">
              {{detailForm.operatorId}}
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="标识1：有效 -1：被删除" prop="state">
              {{detailForm.state}}
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-dialog>

    <el-dialog title="编辑" :visible.sync="editFormVisible" :width="editFormDialogWidth" left>
      <el-form class="edit-form-dialog" ref="editForm" :model="editForm" :label-width="formLabelWidth" :rules="editFormRules">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="项目" prop="projectId">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="editForm.projectId" placeholder="请输入项目" auto-complete="off" maxlength="19" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="阶段名称" prop="name">
              <el-input style="width: 100%;" :size="componentSize" v-model="editForm.name" placeholder="请输入阶段名称" auto-complete="off" maxlength="255" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="序号" prop="sn">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="editForm.sn" placeholder="请输入序号" auto-complete="off" maxlength="10" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="备注" prop="remark">
              <el-input style="width: 100%;" :size="componentSize" v-model="editForm.remark" placeholder="请输入备注" auto-complete="off" maxlength="255" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学习顺序" prop="learningOrder">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="editForm.learningOrder" placeholder="请输入学习顺序" auto-complete="off" maxlength="10" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学分奖励" prop="gradeReward">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="editForm.gradeReward" placeholder="请输入学分奖励" auto-complete="off" maxlength="10" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="学习进度" prop="learningRate">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="editForm.learningRate" placeholder="请输入学习进度" auto-complete="off" maxlength="10" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证书奖励" prop="certificateReward">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="editForm.certificateReward" placeholder="请输入证书奖励" auto-complete="off" maxlength="19" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="操作人id" prop="operatorId">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="editForm.operatorId" placeholder="请输入操作人id" auto-complete="off" maxlength="19" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="标识1：有效 -1：被删除" prop="state">
              <el-input style="width: 100%;" :size="componentSize" type="number" v-model="editForm.state" placeholder="请输入标识1：有效 -1：被删除" auto-complete="off" maxlength="10" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="修改时间" prop="updateTime">
              <el-date-picker style="width: 100%;" :size="componentSize"
                v-model="editForm.updateTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="datetime"
                align="right"
                placeholder="选择日期时间"
                :picker-options="pickerOptions" clearable>
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: center">
        <el-button :size="componentSize" @click="editFormVisible = false">取 消</el-button>
        <el-button :size="componentSize" type="primary" @click="updateProjectPhase">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="导入" :visible.sync="importFormVisible" width="80%" left>
      <el-upload
        class="upload-demo"
        action=""
        :http-request="upload"
        :file-list="fileList">
        <el-button :size="componentSize" size="small" type="primary" icon="el-icon-upload">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">只能上传xls、xlsx文件，且不超过1024kb</div>
      </el-upload>
      <el-table :size="componentSize" ref="multipleTable" :data="importForm.rows" tooltip-effect="dark" style="margin-top: 20px; width: 100%;"
                 border @selection-change="selectionChange">
       <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="projectId" label="项目"></el-table-column>
        <el-table-column prop="name" label="阶段名称"></el-table-column>
        <el-table-column prop="sn" label="序号"></el-table-column>
        <el-table-column prop="remark" label="备注"></el-table-column>
        <el-table-column prop="learningOrder" label="学习顺序"></el-table-column>
        <el-table-column prop="gradeReward" label="学分奖励"></el-table-column>
        <el-table-column prop="learningRate" label="学习进度"></el-table-column>
        <el-table-column prop="certificateReward" label="证书奖励"></el-table-column>
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <el-table-column prop="operatorId" label="操作人id"></el-table-column>
        <el-table-column prop="state" label="标识1：有效 -1：被删除"></el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer" style="text-align: left">
        <el-button :size="componentSize" type="primary" @click="importData" icon="el-icon-document">导入数据</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        tableLoading: false,
        blockAddProjectPhase: false,
        blockEditProjectPhase: false,
        blockDeleteProjectPhase: false,
        blockBatchDeleteProjectPhase: false,
        page: {
          rows: [],
          total: 0,
          pageSize: 10,
          pageNumber: 1,
            sortName: 'id',
          sortOrder: 'asc'
        },
        componentSize: '',
        addFormDialogWidth: '',
        detailFormDialogWidth: '',
        editFormDialogWidth: '',
        addFormVisible: false,
        detailFormVisible: false,
        editFormVisible: false,
        importFormVisible: false,
        searchForm: {
          projectId: null,
          name: null,
        },
        addForm: {
          id: null,
          projectId: null,
          name: null,
          sn: null,
          remark: null,
          learningOrder: null,
          gradeReward: null,
          learningRate: null,
          certificateReward: null,
          createTime: null,
          operatorId: null,
          state: null,
        },
        addFormRules: {
        id: [{
          required: true,
          message: '请输入id',
          trigger: 'blur'
        }],
        projectId: [{
          required: false,
          message: '请输入项目',
          trigger: 'blur'
        }],
        name: [{
          required: false,
          message: '请输入阶段名称',
          trigger: 'blur'
        }, {
          min: 0,
          max: 255,
          message: '阶段名称长度在0-255个字'
        }],
        sn: [{
          required: false,
          message: '请输入序号',
          trigger: 'blur'
        }],
        remark: [{
          required: false,
          message: '请输入备注',
          trigger: 'blur'
        }, {
          min: 0,
          max: 255,
          message: '备注长度在0-255个字'
        }],
        learningOrder: [{
          required: false,
          message: '请输入学习顺序',
          trigger: 'blur'
        }],
        gradeReward: [{
          required: false,
          message: '请输入学分奖励',
          trigger: 'blur'
        }],
        learningRate: [{
          required: false,
          message: '请输入学习进度',
          trigger: 'blur'
        }],
        certificateReward: [{
          required: false,
          message: '请输入证书奖励',
          trigger: 'blur'
        }],
        operatorId: [{
          required: false,
          message: '请输入操作人id',
          trigger: 'blur'
        }],
        state: [{
          required: false,
          message: '请输入标识1：有效 -1：被删除',
          trigger: 'blur'
        }],
        },
        detailForm: {
          id: null,
          projectId: null,
          name: null,
          sn: null,
          remark: null,
          learningOrder: null,
          gradeReward: null,
          learningRate: null,
          certificateReward: null,
          operatorId: null,
          state: null,
          updateTime: null,
        },
        editForm: {
          id: null,
          projectId: null,
          name: null,
          sn: null,
          remark: null,
          learningOrder: null,
          gradeReward: null,
          learningRate: null,
          certificateReward: null,
          operatorId: null,
          state: null,
          updateTime: null,
        },
        editFormRules: {
          id: [{
            required: true,
            message: '请输入id',
            trigger: 'blur'
          }],
          projectId: [{
            required: false,
            message: '请输入项目',
            trigger: 'blur'
          }],
          name: [{
            required: false,
            message: '请输入阶段名称',
            trigger: 'blur'
          }, {
            min: 0,
            max: 255,
            message: '阶段名称长度在0-255个字'
          }],
          sn: [{
            required: false,
            message: '请输入序号',
            trigger: 'blur'
          }],
          remark: [{
            required: false,
            message: '请输入备注',
            trigger: 'blur'
          }, {
            min: 0,
            max: 255,
            message: '备注长度在0-255个字'
          }],
          learningOrder: [{
            required: false,
            message: '请输入学习顺序',
            trigger: 'blur'
          }],
          gradeReward: [{
            required: false,
            message: '请输入学分奖励',
            trigger: 'blur'
          }],
          learningRate: [{
            required: false,
            message: '请输入学习进度',
            trigger: 'blur'
          }],
          certificateReward: [{
            required: false,
            message: '请输入证书奖励',
            trigger: 'blur'
          }],
          operatorId: [{
            required: false,
            message: '请输入操作人id',
            trigger: 'blur'
          }],
          state: [{
            required: false,
            message: '请输入标识1：有效 -1：被删除',
            trigger: 'blur'
          }],
        },
        importForm: {},
        searchFormLabelWidth: '0px',
        formLabelWidth: '80px',
        selection: '',
        multipleSelection: '',
        ids: [],
        rangePickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近六个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 180)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一年',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 365)
              picker.$emit('pick', [start, end])
            }
          }]
        },
        pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date())
            }
          }, {
            text: '昨天',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24)
              picker.$emit('pick', date)
            }
          }, {
            text: '一周前',
            onClick(picker) {
              const date = new Date()
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', date)
            }
          }]
        },
        fileList: [],
        loading: false,
        permissions: []
      }
    },
    methods: {
      setComponentSize() {
        if(document.body.clientWidth <= 992) {
          this.componentSize = 'mini'
          return
        }
        if(document.body.clientWidth <= 1200) {
          this.componentSize = 'small'
          return
        }
        if(document.body.clientWidth <= 1920) {
          this.componentSize = 'medium'
          return
        }
      },
      setDialogWidth() {
        if(document.body.clientWidth > 1366) {
          this.addFormDialogWidth = '60%'
        }else {
          this.addFormDialogWidth = '75%'
        }
        if(document.body.clientWidth > 1366) {
          this.detailFormDialogWidth = '60%'
        }else {
          this.detailFormDialogWidth = '75%'
        }
        if(document.body.clientWidth > 1366) {
          this.editFormDialogWidth = '60%'
        }else {
          this.editFormDialogWidth = '75%'
        }
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize
        this.pageList()
      },
      currentChange(pageNumber) {
        this.page.pageNumber = pageNumber
        this.pageList()
      },
      selectionChange(val) {
        this.multipleSelection = val
        this.ids = []
        val.forEach(e => this.ids.push({id: e.id}))
      },
      getProjectPhaseDetail() {
        this.api.projectPhase.getProjectPhaseDetail({
          id: this.selection
        }).then(result => {
          if(result.success) {
            this.detailForm = result.data
          }else {
            this.$message.error(result.message)
          }
        }).catch(error => {
          console.log(error)
        })
      },
      getProjectPhaseById() {
        this.api.projectPhase.getProjectPhaseById(this.selection)
        .then(result => {
          if(result.success) {
            this.editForm = result.data
          }else {
            this.$message.error(result.message)
          }
        }).catch(error => {
          console.log(error)
        })
      },
      pageList() {
        this.tableLoading = true
        this.searchForm.pageSize = this.page.pageSize
        this.searchForm.pageNumber = this.page.pageNumber
        this.searchForm.sortName = this.page.sortName
        this.searchForm.sortOrder = this.page.sortOrder
        this.api.projectPhase.pageList(this.searchForm).then(result => {
          this.page.rows = result.data.records
          this.page.total = result.data.total
          this.tableLoading = false
        }).catch(error => {
          console.log(error)
        })
      },
      addProjectPhase() {
        if(this.blockAddProjectPhase) {
          return false
        }
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.blockAddProjectPhase = true
            this.api.projectPhase.addProjectPhase(this.addForm).then(result => {
              if (result.success) {
                this.$message.success(result.message)
                this.addFormVisible = false
              }else {
                this.$message.error(result.message)
              }
              this.blockAddProjectPhase = false
            }).catch(error => {
              this.blockAddProjectPhase = false
              console.log(error)
            })
          } else {
            return false
          }
        })
      },
      updateProjectPhase() {
        if(this.blockEditProjectPhase) {
          return false
        }
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.blockEditProjectPhase = true
            this.api.projectPhase.updateProjectPhase(this.editForm).then(result => {
              if(result.success) {
                this.$message.success(result.message)
                this.editFormVisible = false
                this.pageList()
              }else {
                this.$message.error(result.message)
              }
              this.blockEditProjectPhase = false
            }).catch(error => {
              this.blockEditProjectPhase = false
              console.log(error)
            })
          } else {
            return false
          }
        })
      },
      deleteProjectPhase(row) {
        if(this.blockDeleteProjectPhase) {
          return false
        }
        this.$confirm('您确定要进行删除操作吗？', '系统消息', {
          type: 'warning'
        }).then(()=> {
          this.blockDeleteProjectPhase = true
          this.api.projectPhase.deleteProjectPhase([{
            id: row.id
          }]).then(result => {
            if(result.success) {
              this.$message.success(result.message)
              this.pageList()
            }else {
              this.$message.error(result.message)
            }
            this.blockDeleteProjectPhase = false
          }).catch(error => {
            this.blockDeleteProjectPhase = false
            console.log(error)
          })
        }).catch(() => {

        })
      },
      batchDeleteProjectPhase() {
        if(this.blockBatchDeleteProjectPhase) {
          return false
        }
        if(this.ids.length === 0) {
          this.$message.error('请选择要删除的数据！')
          return false
        }
        this.$confirm('您确定要进行删除操作吗？', '系统消息', {
          type: 'warning'
        }).then(()=> {
          this.blockBatchDeleteProjectPhase = true
          this.api.projectPhase.deleteProjectPhase(this.ids).then(result => {
            if(result.success) {
              this.$message.success(result.message)
              this.pageList()
            }else {
              this.$message.error(result.message)
            }
            this.blockBatchDeleteProjectPhase = false
          }).catch(error => {
            this.blockBatchDeleteProjectPhase = false
            console.log(error)
          })
        }).catch(() => {

        })
      },
      reset() {
        this.$refs.searchForm.resetFields()
        this.pageList()
      },
      handleSuccess (response, file, fileList, $event) {
        this.importForm = response.data
      },
      exportExcel() {
        this.loading = true
        this.api.projectPhase.exportExcel(this.searchForm).then(result => {
          location.href = result.data
          this.loading = false
        }).catch(error => {
          console.log(error)
        })
      },
      importData() {
        this.api.projectPhase.importData(this.importForm.rows).then(result => {
          if(result.success) {
            this.$message.success(result.message)
            this.importFormVisible = false
          }else {
            this.$message.error(result.message)
          }
        }).catch(error => {
          console.log(error)
        })
      },
      active(row) {
        this.api.projectPhase.active(row).then(result => {
          if(result.success) {
            this.$message.success(result.message)
          }else {
            this.$message.error(result.message)
          }
          this.pageList()
        }).catch(error => {
          console.log(error)
        })
      },
      getPermissionList() {
        let user = JSON.parse(localStorage.user)
        user.resources.forEach(e => {
          e.resources.forEach(a => {
            a.resources.forEach(x => this.permissions.push(x.url))
          })
        })
      },
      upload(file) {
        this.api.upload.stsToken().then(result => {
          if(!result.success) {
            this.$message.error(result.message)
          }
          if (file.file.size / 1024 / 1024 > 1) {
            this.$message.error("图片大小不能超过1M");
          } else {
            this.api.upload.uploadOSS(file, result.data, 'projectPhase').then(result => {

            })
          }
        })
      }
    },
    watch: {
      'addFormVisible': function (newVal) {
        if (!newVal) {
          this.$refs.addForm.resetFields()
          this.pageList()
        } else {
        }
      },
      'detailFormVisible': function (newVal) {
        if (newVal) {
          let loading = this.$loading.service({
            text: '请稍等',
            target: document.querySelector('.detail-form-dialog')
          })
          this.getProjectPhaseDetail()
          loading.close()
        }
      },
      'editFormVisible': function (newVal) {
        if (!newVal) {
          this.$refs.editForm.resetFields()
          this.pageList()
        } else {
          let loading = this.$loading.service({
            text: '请稍等',
            target: document.querySelector('.edit-form-dialog')
          })
          this.getProjectPhaseById()
          loading.close()
        }
      }
    },
    mounted() {
      this.setComponentSize()
      this.setDialogWidth()
      // this.getPermissionList()
      this.pageList()
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/projectPhase/index.vue